// 下载文件流
export const downloadFileStream = (data, name) => {
  const url = window.URL.createObjectURL(new Blob([data]))
  let el = document.createElement('a')
  el.href = url
  el.setAttribute('download', `${name}.xlsx`)
  document.body.appendChild(el)
  el.click()
  document.body.removeChild(el)
  window.URL.revokeObjectURL(url) // 释放掉blob对象
}

const FILE_UNITS = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
/**
 * 文件大小转换
 * @param x 字节
 * @returns
 */
export const niceBytes = (x) => {
  let l = 0,
    n = parseInt(x, 10) || 0

  while (n >= 1024 && ++l) {
    n = n / 1024
  }

  return n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + FILE_UNITS[l]
}

interface KV {
  key: string
  val: string
}

interface DICToolParams {
  ignoreCase: boolean
}
export class DICTool {
  arr: Array<KV> = []
  data: object = {}
  config: DICToolParams
  constructor(args, params: DICToolParams = { ignoreCase: true }) {
    this.config = params
    if (Array.isArray(args)) {
      this.arr = args
      this.data = {}
      this.arr.forEach((obj) => {
        if (params.ignoreCase) {
          this.data[obj.key?.toLowerCase()] = obj.val
        } else {
          this.data[obj.key] = obj.val
        }
      })
    }
  }
  get(key, defaultValue?) {
    if (this.config.ignoreCase) {
      return this.data[key?.toLowerCase()] || defaultValue
    } else {
      return this.data[key] || defaultValue
    }
  }
}
